import { Alert, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import { useTranslation } from "react-i18next";
import { ValidationResult } from "../validation/menu-validators";

interface RuleExplanationProps {
    validationResult: ValidationResult;
    type?: "info" | "warning";
}

/**
 * Gives information about the menu group constraints and help text when needed
 */
const RuleExplanation = ({
    validationResult,
    type = validationResult.isValid ? "info" : "warning",
}: RuleExplanationProps) => {
    const { t } = useTranslation();

    if (!validationResult.messageKey) {
        return null;
    }

    const message = t(validationResult.messageKey, validationResult.messageParams || {});

    const hasHelpText = !validationResult.isValid && validationResult.helpTextKey;
    const helpText =
        hasHelpText && validationResult.helpTextKey
            ? t(validationResult.helpTextKey, validationResult.helpTextParams || {})
            : null;

    const fullText = `${message} ${hasHelpText ? ` ${helpText}` : ""}`;

    return (
        <Alert type={type} mb={ThemeSpaceVariable.Medium}>
            {fullText}
        </Alert>
    );
};

export default RuleExplanation;
